<!-- Path: libs/components/modal/src/lib/ui-modal-change-list/ui-modal-change-list.component.html -->
<div class="ui-modal-change-list">
  @for (item of items(); track item.label) {
    <article class="ui-modal-change-list__item">
      <strong class="ui-modal-change-list__label">
        {{ item.label }}
      </strong>

      <div class="ui-modal-change-list__values">
        <div class="ui-modal-change-list__block">
          <span class="ui-modal-change-list__caption">
            {{ previousLabel() }}
          </span>

      <span class="ui-modal-change-list__value ui-modal-change-list__value--previous">
            {{ item.previous }}
          </span>
        </div>

        <div class="ui-modal-change-list__arrow" aria-hidden="true">
          →
        </div>

        <div class="ui-modal-change-list__block">
          <span class="ui-modal-change-list__caption">
            {{ currentLabel() }}
          </span>

          <span class="ui-modal-change-list__value ui-modal-change-list__value--next">
            {{ item.current }}
          </span>
        </div>
      </div>
    </article>
  }
</div>